/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  MediaFileStaffApiOutContract,
  PostPatientsPatientIdMediafilesBody,
  UpdateMediaFileStaffApiInContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPatientsPatientIdMediafiles = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<MediaFileStaffApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/mediafiles`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdMediafilesInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/mediafiles`
    ] as const;
    }

export const getGetPatientsPatientIdMediafilesQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/mediafiles`
    ] as const;
    }

    
export const getGetPatientsPatientIdMediafilesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdMediafilesInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>> = ({ signal }) => getPatientsPatientIdMediafiles(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdMediafilesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>
export type GetPatientsPatientIdMediafilesInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdMediafilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdMediafilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdMediafilesInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdMediafilesInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdMediafilesInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdMediafilesQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdMediafilesQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>> = ({ signal }) => getPatientsPatientIdMediafiles(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdMediafilesQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>
export type GetPatientsPatientIdMediafilesQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdMediafiles<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafiles<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafiles<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdMediafiles<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdMediafilesQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdMediafilesQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdMediafilesQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdMediafilesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdMediafilesQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>> = ({ signal }) => getPatientsPatientIdMediafiles(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdMediafilesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>
export type GetPatientsPatientIdMediafilesSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdMediafilesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdMediafilesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdMediafilesSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdMediafilesSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdMediafilesInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>> = ({ signal }) => getPatientsPatientIdMediafiles(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdMediafilesSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>
export type GetPatientsPatientIdMediafilesSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdMediafilesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdMediafilesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafiles>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdMediafilesSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postPatientsPatientIdMediafiles = (
    patientId: string,
    postPatientsPatientIdMediafilesBody: PostPatientsPatientIdMediafilesBody,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(postPatientsPatientIdMediafilesBody.file !== undefined) {
 formData.append(`file`, postPatientsPatientIdMediafilesBody.file)
 }
if(postPatientsPatientIdMediafilesBody.drugScreenCompleteDate !== undefined) {
 formData.append(`drugScreenCompleteDate`, postPatientsPatientIdMediafilesBody.drugScreenCompleteDate)
 }
if(postPatientsPatientIdMediafilesBody.drugScreenExpireDate !== undefined) {
 formData.append(`drugScreenExpireDate`, postPatientsPatientIdMediafilesBody.drugScreenExpireDate)
 }
if(postPatientsPatientIdMediafilesBody.tags !== undefined) {
 postPatientsPatientIdMediafilesBody.tags.forEach(value => formData.append(`tags`, value));
 }

      return fetcher<MediaFileStaffApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/mediafiles`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostPatientsPatientIdMediafilesMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdMediafiles>>, TError,{patientId: string;data: PostPatientsPatientIdMediafilesBody}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdMediafiles>>, TError,{patientId: string;data: PostPatientsPatientIdMediafilesBody}, TContext> => {

const mutationKey = ['postPatientsPatientIdMediafiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPatientsPatientIdMediafiles>>, {patientId: string;data: PostPatientsPatientIdMediafilesBody}> = (props) => {
          const {patientId,data} = props ?? {};

          return  postPatientsPatientIdMediafiles(patientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPatientsPatientIdMediafilesMutationResult = NonNullable<Awaited<ReturnType<typeof postPatientsPatientIdMediafiles>>>
    export type PostPatientsPatientIdMediafilesMutationBody = PostPatientsPatientIdMediafilesBody
    export type PostPatientsPatientIdMediafilesMutationError = void | ErrorApiOutContract

    export const usePostPatientsPatientIdMediafiles = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdMediafiles>>, TError,{patientId: string;data: PostPatientsPatientIdMediafilesBody}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPatientsPatientIdMediafiles>>,
        TError,
        {patientId: string;data: PostPatientsPatientIdMediafilesBody},
        TContext
      > => {

      const mutationOptions = getPostPatientsPatientIdMediafilesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getPatientsPatientIdMediafilesFileId = (
    patientId: string,
    fileId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<MediaFileStaffApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/mediafiles/${encodeURIComponent(String(fileId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdMediafilesFileIdInfiniteQueryKey = (patientId?: string,
    fileId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/mediafiles/${fileId}`
    ] as const;
    }

export const getGetPatientsPatientIdMediafilesFileIdQueryKey = (patientId?: string,
    fileId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/mediafiles/${fileId}`
    ] as const;
    }

    
export const getGetPatientsPatientIdMediafilesFileIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>, TError = void | ErrorApiOutContract>(patientId: string,
    fileId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdMediafilesFileIdInfiniteQueryKey(patientId,fileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>> = ({ signal }) => getPatientsPatientIdMediafilesFileId(patientId,fileId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && fileId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdMediafilesFileIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>
export type GetPatientsPatientIdMediafilesFileIdInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdMediafilesFileIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesFileIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesFileIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdMediafilesFileIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdMediafilesFileIdInfiniteQueryOptions(patientId,fileId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdMediafilesFileIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    fileId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdMediafilesFileIdInfiniteQueryOptions(patientId,fileId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdMediafilesFileIdQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(patientId: string,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdMediafilesFileIdQueryKey(patientId,fileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>> = ({ signal }) => getPatientsPatientIdMediafilesFileId(patientId,fileId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && fileId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdMediafilesFileIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>
export type GetPatientsPatientIdMediafilesFileIdQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdMediafilesFileId<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesFileId<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesFileId<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdMediafilesFileId<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdMediafilesFileIdQueryOptions(patientId,fileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdMediafilesFileIdQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdMediafilesFileIdQueryOptions(patientId,fileId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdMediafilesFileIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(patientId: string,
    fileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdMediafilesFileIdQueryKey(patientId,fileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>> = ({ signal }) => getPatientsPatientIdMediafilesFileId(patientId,fileId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdMediafilesFileIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>
export type GetPatientsPatientIdMediafilesFileIdSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdMediafilesFileIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesFileIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesFileIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdMediafilesFileIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdMediafilesFileIdSuspenseQueryOptions(patientId,fileId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdMediafilesFileIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>, TError = void | ErrorApiOutContract>(patientId: string,
    fileId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdMediafilesFileIdInfiniteQueryKey(patientId,fileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>> = ({ signal }) => getPatientsPatientIdMediafilesFileId(patientId,fileId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdMediafilesFileIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>
export type GetPatientsPatientIdMediafilesFileIdSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdMediafilesFileIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesFileIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdMediafilesFileIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdMediafilesFileIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    fileId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdMediafilesFileId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdMediafilesFileIdSuspenseInfiniteQueryOptions(patientId,fileId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putPatientsPatientIdMediafilesFileId = (
    patientId: string,
    fileId: string,
    updateMediaFileStaffApiInContract: UpdateMediaFileStaffApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<MediaFileStaffApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/mediafiles/${encodeURIComponent(String(fileId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMediaFileStaffApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdMediafilesFileIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdMediafilesFileId>>, TError,{patientId: string;fileId: string;data: UpdateMediaFileStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdMediafilesFileId>>, TError,{patientId: string;fileId: string;data: UpdateMediaFileStaffApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdMediafilesFileId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdMediafilesFileId>>, {patientId: string;fileId: string;data: UpdateMediaFileStaffApiInContract}> = (props) => {
          const {patientId,fileId,data} = props ?? {};

          return  putPatientsPatientIdMediafilesFileId(patientId,fileId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdMediafilesFileIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdMediafilesFileId>>>
    export type PutPatientsPatientIdMediafilesFileIdMutationBody = UpdateMediaFileStaffApiInContract
    export type PutPatientsPatientIdMediafilesFileIdMutationError = void | ErrorApiOutContract

    export const usePutPatientsPatientIdMediafilesFileId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdMediafilesFileId>>, TError,{patientId: string;fileId: string;data: UpdateMediaFileStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdMediafilesFileId>>,
        TError,
        {patientId: string;fileId: string;data: UpdateMediaFileStaffApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdMediafilesFileIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    